import { render, staticRenderFns } from "./receiving-details-comp.vue?vue&type=template&id=9d9755fa&"
import script from "./js/receiving-details-comp.js?vue&type=script&lang=js&"
export * from "./js/receiving-details-comp.js?vue&type=script&lang=js&"
import style0 from "./receiving-details-comp.vue?vue&type=style&index=0&id=9d9755fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports